<div class="flex w-full flex-col gap-1">
  @if (label()) {
    <span class="block self-start text-sm text-(--ig-editor-text-color,#ffffff)">{{ label() }}</span>
  }

  <div
    class="flex h-(--ig-editor-field-height,2.33em) w-full items-stretch overflow-hidden rounded-(--ig-editor-field-radius,6px) border border-(--ig-editor-field-border-color,transparent) bg-(--ig-editor-field-bg,#2b2e32) text-sm transition-[border-color,box-shadow] duration-150 focus-within:border-(--ig-editor-focus-border-color,var(--ig-editor-field-border-color,transparent)) focus-within:shadow-[0_0_0_3px_var(--ig-editor-focus-shadow,transparent)]">
    <input
      [id]="inputId()"
      [type]="type()"
      class="min-w-0 flex-1 h-full m-0 border-0 bg-transparent py-0 px-2 text-sm leading-7.5 text-(--ig-editor-text-color,#ffffff) placeholder:opacity-45 focus:outline-none read-only:cursor-default"
      [value]="value() ?? ''"
      [placeholder]="placeholder()"
      [readonly]="readonly()"
      (input)="applyValue($event)" />
  </div>
</div>
